import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Table } from 'primeng/table';
import { refreshTable } from '../helpers/helper'
import { ApiService } from '../services/api.service';

@Component({
    selector: 'app-simplecardtitle',
    template: `
        <p-card>
            <div class="p-d-flex">
                <span class="card-title" *ngIf="title !== null">{{title}}</span>
                <span class="p-ml-auto">
                    <ng-content></ng-content>
                </span>
            </div>
        </p-card>
    `,
    styles: [':host {margin-bottom: 16px; display: block;}']
})
export class SimpleCardTitleComponent implements OnInit {
    @Input() title: string|null = null;
    @Input() sticky: boolean = false;
    constructor(
        private el: ElementRef
    ) { }
    ngOnInit(): void {
        const element: HTMLElement = this.el.nativeElement;
        if (this.sticky) {
            element.style.position = 'sticky';
            element.style.top = '0';
            element.style.zIndex = '2';
        }
    }
}

@Component({
    template: ''
})
export class UnsubscribeComponent implements OnDestroy {
    unsubscribe: Subject<void> = new Subject();
    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}

@Component({
    template: ''
})
export class SimpleTableComponent<T> extends UnsubscribeComponent implements AfterViewInit {
    @ViewChild('table') table: Table = null;
    data: T[];
    rowCount = 0;
    loading = false;
    endPoint: string|null = null;
    loadData(): void {
        if (this.endPoint === null) {
            return;
        }
        this.loading = true;
        this.changeDetection.detectChanges();
        this.apiService.getSimpleTable<T>(this.endPoint, this.table.createLazyLoadMetadata()).pipe(takeUntil(this.unsubscribe)).subscribe((rsp) => {
            this.data = rsp.data;
            this.rowCount = rsp.rowCount;
            this.loading = false;
        }).add(() => {
            this.changeDetection.detectChanges();
        });
    }

    ngAfterViewInit(): void {
        if (!(this.table instanceof Table)) {
            return;
        }
        this.table.onLazyLoad.pipe(
            takeUntil(this.unsubscribe)
        ).subscribe(() => this.loadData());
        refreshTable(this.table);
    }
    refreshTable(): void {
        refreshTable(this.table);
    }

    constructor(
        private changeDetection: ChangeDetectorRef,
        private apiService: ApiService
    ) {
        super();
    }
}
